import { fixedIds } from "app_config"
import { axiosbaseurl } from "configure"
import { designation_options } from "constants/layout"
import React, { useEffect, useState } from "react"
import swal from "sweetalert"

const TasksCreate = ({ tasks, setTasks, serviceId, frequencyType }) => {
  const [frequency_options, setfrequency_options] = useState([])

  function onAdd(data, setData) {
    setData(ref => [
      ...ref,
      {
        id: data.length + 1,
        task_name: "",
        frequency: frequencyType === "variable" ? "" : frequencyType,
        dateLabel: "",
        days: "",
        // primaryDesignation: ""
      },
    ])
  }

  const customFrequency = [
    {
      value: "weekly",
      label: "Weekly",
    },
    {
      value: "monthly",
      label: "Monthly",
    },
    {
      value: "quarterly",
      label: "Quarterly",
    },
    {
      value: "annually",
      label: "Annually",
    },
  ]

  useEffect(() => {
    if (frequencyType === "payroll-variable") {
      const getDatas = async () => {
        try {
          const { data } = await axiosbaseurl.get(`/payroll-frequency`)
          if (data.success) {
            setfrequency_options(
              data.data.map(p => ({
                value: p.payrollFrequency,
                label: p.payrollFrequency,
              }))
            )
          }
        } catch (error) {
          console.log(error)
        }
      }
      getDatas()
    } else {
      setfrequency_options(customFrequency)
    }
  }, [frequencyType])

  function onRemove(id, data, setData) {
    swal({
      title: "Are you sure?",
      text: "You want to remove this task",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async willdelete => {
      if (willdelete) {
        const temprows = [...data]
        temprows.splice(id, 1)
        setData(temprows.map((ref, i) => ({ ...ref, id: i + 1 })))
      }
    })
  }

  const handleChangeTaskData = (index, keyname, value, setData) => {
    setData(datas => {
      let oldFood = [...datas]
      oldFood[index][keyname] = value
      return oldFood
    })
  }

  const isBM = [fixedIds.bookkeeping, fixedIds.managementAccount].includes(
    serviceId
  )

  function getUpcomingSunday(date = new Date()) {
    const d = new Date(date)
    const day = d.getUTCDay()
    const daysToAdd = day === 0 ? 7 : 7 - day
    return new Date(
      Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate() + daysToAdd)
    )
  }

  function getMonthEndDate(date = new Date()) {
    const d = new Date(date)
    return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + 1, 0))
  }

  function formatDate(date) {
    const dd = String(date.getDate()).padStart(2, "0")
    const mm = String(date.getMonth() + 1).padStart(2, "0")
    const yyyy = date.getFullYear()
    return `${dd}/${mm}/${yyyy}`
  }

  const datesOptions = [
    {
      label: `Week End (${formatDate(getUpcomingSunday())})`,
      value: "weekEnd",
    },
    {
      label: `Month End (${formatDate(getMonthEndDate())})`,
      value: "monthEnd",
    },
    {
      label: "Current MTD Period End - (MTD)",
      value: "currentMTDPeriodEnd",
    },
    {
      label: "Current MTD Period Due - (MTD)",
      value: "currentMTDPeriodDue",
    },
    {
      label: "Current Year End - (Account & Tax)",
      value: "accountsAndTaxCurrentYearDueDate",
    },
    {
      label: "Current Financial/Tax Year Due - (Account & Tax)",
      value: "accountsAndTaxNextYearDueDate",
    },
    {
      label: "CS Current Year - (Confirmation statement)",
      value: "CScurrentYearDueDate",
    },
    {
      label: "CS Due Date - (Confirmation statement)",
      value: "currentCSYearDueDate",
    },

    { label: "First VAT Period End - (VAT Return)", value: "VATFirstPeriod" },
    {
      label: "Current VAT Period End - (VAT Return)",
      value: "VATCurrentPeriodEnd",
    },
    {
      label: "Current Period Due Date - (VAT Return)",
      value: "VATCurrentPeriodDueDate",
    },

    { label: "Current Period End - (CIS Return)", value: "CISDate" },
    { label: "Current Period Due Date - (CIS Return)", value: "CISDueDate" },

    // { label: "Weekly Date - (Payroll)", value: "payrollFirstWeeklyDate" },
    // { label: "Weekly Due Date - (Payroll)", value: "payrollSecondWeeklyDate" },
    // {
    //   label: "Fortnightly Date - (Payroll)",
    //   value: "payrollFirstFortNightlyDate",
    // },
    // {
    //   label: "Fortnightly Due Date - (Payroll)",
    //   value: "payrollSecondFortNightlyDate",
    // },
    // {
    //   label: "Fourweekly Date- (Payroll)",
    //   value: "payrollFirstFourWeeklyDate",
    // },
    // {
    //   label: "Fourweekly Due Date- (Payroll)",
    //   value: "payrollSecondFourWeeklyDate",
    // },
    // { label: "Monthly Date- (Payroll)", value: "payrollFirstMonthlyDate" },
    // { label: "Monthly Due Date- (Payroll)", value: "payrollSecondMonthlyDate" },

    {
      label: "Bookkeeping First Period End- (Bookkeeping)",
      value: "bookkeepingFirstPeriodEnd",
    },
    {
      label: "Current Period End - (Bookkeeping)",
      value: "bookkeepingCurrentPeriodEnd",
    },
    {
      label: "Current Period Due Date - (Bookkeeping)",
      value: "bookkeepingCurrentPeriodDueDate",
    },

    {
      label: "MA First Period End - (Management Account)",
      value: "managementAccountFirstPeriodEnd",
    },

    {
      label: "Current Period End - (Management Account)",
      value: "managementAccountCurrentPeriodEndDate",
    },
    {
      label: "Current Period Due Date - (Management Account)",
      value: "managementAccountCurrentPeriodDueDate",
    },
  ]

  return (
    <div className="row">
      <div className="col-12 mb-3">
        <div className="d-flex justify-content-between align-items-center mt-2">
          <p className="text-danger mb-1" style={{ fontSize: "13px" }}>
            <i className="fas fa-info-circle me-1"></i>
            <strong>Note:</strong> Frequency plays no role when client date
            label is Week End ({formatDate(getUpcomingSunday())}) or Month End ({formatDate(getMonthEndDate())}).
          </p>
          <button
            type="button"
            onClick={() => onAdd(tasks, setTasks)}
            className="btn btn-primary py-2 fs-6 px-2"
            style={{ cursor: "pointer" }}
          >
            <i className="fas fa-plus me-1"></i> Add New Task
          </button>
        </div>
      </div>

      <div className="border" />
      <div className="col-12">
        {tasks?.map((ref, index) => {
          return (
            <div
              key={ref.id}
              className={`row pb-3 ${index % 2 !== 0 && "bg-primary bg-soft"}`}
            >
              <div className="col-md-3 mt-3">
                <label className="label-text">
                  {" "}
                  Task Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter Task Name  "
                  className="form-control input-field"
                  name="task_name"
                  value={ref.task_name}
                  onChange={e => {
                    handleChangeTaskData(
                      index,
                      "task_name",
                      e.target.value,
                      setTasks
                    )
                  }}
                  required
                />
              </div>

              <div className="col-md-3 mt-3">
                <label className="label-text">
                  {" "}
                  Client Date Label <span className="text-danger">*</span>
                </label>
                <select
                  name="dateLabel"
                  value={ref.dateLabel}
                  onChange={e => {
                    const val = e.target.value
                    handleChangeTaskData(index, "dateLabel", val, setTasks)
                    if (
                      val === "currentMTDPeriodEnd" ||
                      val === "currentMTDPeriodDue"
                    ) {
                      handleChangeTaskData(
                        index,
                        "frequency",
                        "quarterly",
                        setTasks
                      )
                    } else if (val === "weekEnd") {
                      handleChangeTaskData(
                        index,
                        "frequency",
                        "weekly",
                        setTasks
                      )
                    } else if (val === "monthEnd") {
                      handleChangeTaskData(
                        index,
                        "frequency",
                        "monthly",
                        setTasks
                      )
                    }
                  }}
                  required
                  className="form-select input-field status_select_dropdown "
                  style={{ paddingRight: "35px" }}
                >
                  <option value=""> Select Date Type</option>
                  {
                    // [serviceId]?
                    datesOptions.map((item, i) => (
                      <option key={i} value={item.value}>
                        {item.label}
                      </option>
                    ))
                  }
                </select>
              </div>

              <div className="col-md-2 mt-3">
                <label className="label-text">
                  {" "}
                  Frequency <span className="text-danger">*</span>
                </label>
                <select
                  name="frequency"
                  value={ref.frequency}
                  onChange={e =>
                    handleChangeTaskData(
                      index,
                      "frequency",
                      e.target.value,
                      setTasks
                    )
                  }
                  required
                  className="form-select input-field"
                  disabled={
                    (frequencyType !== "variable" &&
                      frequencyType !== "payroll-variable") ||
                    ref.dateLabel === "currentMTDPeriodEnd" ||
                    ref.dateLabel === "currentMTDPeriodDue" ||
                    ref.dateLabel === "weekEnd" ||
                    ref.dateLabel === "monthEnd"
                  }
                >
                  <option value=""> Select frequency</option>
                  {frequency_options?.slice(0, isBM ? 2 : 4).map(f => (
                    <option key={f.value} value={f.value}>
                      {f.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-2 mt-3">
                <label className="label-text">
                  {" "}
                  Primary Designation <span className="text-danger">*</span>
                </label>
                <select
                  name="primaryDesignation"
                  value={ref.primaryDesignation}
                  onChange={e =>
                    handleChangeTaskData(
                      index,
                      "primaryDesignation",
                      e.target.value,
                      setTasks
                    )
                  }
                  required
                  className="form-select input-field status_select_dropdown "
                  style={{ paddingRight: "35px" }}
                >
                  <option value=""> Select Designation</option>
                  {
                    // [serviceId]?
                    designation_options.slice(0, 4).map((item, i) => (
                      <option key={item.value} value={item.value}>
                        {item.label}
                      </option>
                    ))
                  }
                </select>
              </div>

              <div className="col-md-2 mt-3">
                <div className="row align-items-end">
                  <div className="col-8">
                    <label className="label-text">
                      {" "}
                      Days before <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      placeholder="e.g. 8"
                      className="form-control input-field"
                      value={ref.days}
                      name="days"
                      min={1}
                      onKeyPress={e => {
                        if (!/\d/.test(e.key)) e.preventDefault()
                      }}
                      onChange={e =>
                        handleChangeTaskData(
                          index,
                          "days",
                          e.target.value,
                          setTasks
                        )
                      }
                      required
                    />
                  </div>
                  <div className="col-4">
                    {index !== 0 && (
                      <button
                        type="button"
                        className="btn btn-danger mb-1"
                        style={{ cursor: "pointer" }}
                        onClick={() => onRemove(index, tasks, setTasks)}
                      >
                        <i className="fas fa-trash "></i>
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default TasksCreate
